import { render, staticRenderFns } from "./ResizeVertical.vue?vue&type=template&id=1cd54d8d"
import script from "./ResizeVertical.vue?vue&type=script&lang=js"
export * from "./ResizeVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports